import {mapGetters} from "vuex";
import TableShared from "../../TableShared/TableShared.vue";

export default {
    name: 'confirmModal',
    components: {},
    data() {
        return {}
    },
    methods: {
        ...mapGetters(['getPaginationPage', 'getFlexiblePage', 'getFilter']),
        changeVision() {
            this.$store.dispatch('changeVisionConfirm')
        },
        changePage(page) {
            this.$emit('updatePageNum', page)
        },
        confirmModal(id) {
            this.$store.dispatch('deleteContent', id)
                .then(resp => {
                    this.$store.dispatch('changeVisionConfirm')
                        .then(() => {
                            this.$store.dispatch('deleteStatus').then()
                        })
                    let validPage = this.$store.getters.getFlexiblePage
                    this.changePage(validPage)
                    let sortObj = this.$store.getters.getSort
                    let sort = sortObj.sort
                    let sortType = sortObj.type
                    let filter = this.$store.getters.getFilter

                    this.$store.dispatch('contentList', {
                        page: validPage,
                        sort: sort,
                        type: sortType,
                        filter: filter
                    }).then(resp => {
                        localStorage.list = JSON.stringify(resp.data.data);
                    })
                })
                .catch((error)=>{
                    console.log(error)
                })
        },
        cancelModal() {
            this.$store.dispatch('changeVisionConfirm').then(()=>{})
        }
    },
    computed: mapGetters(['contentId'])
}
